const headersCallLog = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'квартира',
    value: 'apartment',
  },
  {
    text: 'Домофон',
    value: 'doorphone.address',
  },
  {
    text: 'Изображение',
    value: 'snapshot_path',
    align: 'center',
  },
  {
    text: 'дата и время',
    value: 'createdAt',
  },
];
export { headersCallLog };
